<template>
  <aside class="flex flex-col w-full">
    <PageBuilderSidebarContent v-if="enablePageBuilderSidebar" />
    <template v-else>
      <div
        v-if="content.length"
        class="rec-block"
      >
        <h2 class="sidebar-headline uppercase">Recommended Pages</h2>
      </div>
      <div
        v-for="(page, index) in content"
        :key="'rec-pages-' + index"
        class="rec-block"
      >
        <h3 class="text-xl mb-1">{{ page.title }}</h3>
        <div class="mb-2">
          <p v-html="page.description" />
        </div>
        <div
          v-if="page.cta && page.cta.length"
          class="mb-4"
        >
          <div
            v-for="(cta, i) in page.cta"
            :key="i"
            class="mb-1 flex items-center color-theme-light"
          >
            <BaseIcon
              icon="arrow-circle-right"
              class="mr-2"
            />
            <a
              :href="cta.url"
              target="_blank"
            >{{ cta.label }}</a>
          </div>
        </div>
        <div
          v-if="page.image"
          class="mb-4"
        >
          <img
            class="w-full rounded"
            :src="page.image"
            alt=""
          />
        </div>
      </div>
    </template>
  </aside>
</template>

<script>
import PageBuilderSidebarContent from '@/components/PageBuilderSidebarContent'
import useFeatureFlags from '@/composables/useFeatureFlags'
import { PAGE_BUILDER_SIDEBAR } from '@/constants/featureFlags'

export default {
  setup() {
    const { enablePageBuilderSidebar } = useFeatureFlags({
      enablePageBuilderSidebar: PAGE_BUILDER_SIDEBAR,
    })
    return { enablePageBuilderSidebar }
  },
  components: { PageBuilderSidebarContent },
  props: {
    content: {
      type: Array,
      default: () => [
        /*
          title: String,
          description: String,
          image: Image,
          cta: Array
        */
      ],
    },
  },
}
</script>

<style scoped>
.rec-block {
  @apply text-gray-900 ml-4 py-2;
}
p:not(a) {
  color: var(--textFontColor, var(--text-gray-600));
  font-family: var(--textFontTypeface, inherit);
  font-weight: var(--textFontWeight, inherit);
}

p >>> a {
  color: var(--theme-light, inherit);
}

h3 {
  color: var(--h3HeaderFontColor, --text-gray-800);
  font-family: var(--h3HeaderFontTypeface, inherit);
  font-weight: var(--h3HeaderFontWeight, 600);
}

.sidebar-headline {
  font-family: var(--interfaceFontTypeface, inherit);
  font-weight: var(--interfaceFontWeight, 700);
  color: var(--interfaceFontColor, var(--text-indygo-600));
}
</style>
